import { apiHost } from '@libs/providers/api-host.provider';
import { HttpStatuses } from './blog.service';

function route(slug: string) {
  return `${apiHost()}/web/articles/${slug}`;
}

export function increaseNumberOfViews(slug: string) {
  const url = route(slug);
  if (!url) {
    throw new Error(`Invalid route for slug: ${slug}`);
  }
  const viewsUrl = `${url}/views`;
  return fetch(viewsUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      switch (response.status) {
        case HttpStatuses.received:
        case HttpStatuses.created:
          return 'ok';
        case HttpStatuses.notFound:
          throw new Error('Not found');
        default:
          throw new Error('Smth bad');
      }
    })
    .catch((error) => {
      const isNetworkError = error instanceof TypeError && error.message === 'Failed to fetch';
      throw Object.assign(new Error(`Failed to increase views for article ${slug}`), {
        type: isNetworkError ? 'NETWORK_ERROR' : 'SERVER_ERROR',
        cause: {
          message: (error as Error).message,
          timestamp: new Date().toISOString(),
          url: viewsUrl,
          online: typeof navigator !== 'undefined' ? navigator.onLine : 'unknown',
        },
      });
    });
}

export function getArticle(slug: string) {
  /** actually id is an article slug */
  const articleUrl = `${apiHost()}/web/articles/${encodeURI(slug)}`;

  return fetch(articleUrl).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}

export function setArticleRating(articleId: string, visitorSecret: string, rating: number) {
  const url = `${apiHost()}/web/articles/rating`;
  return fetch(url, {
    method: 'PUT',
    body: JSON.stringify({
      articleId,
      visitorSecret,
      grade: rating,
    }),
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      switch (response.status) {
        case HttpStatuses.received:
        case HttpStatuses.created:
          return response.json();
        case HttpStatuses.notFound:
          throw new Error('Not found');
        default:
          throw new Error('Smth bad');
      }
    })
    .catch((error) => {
      const isNetworkError = error instanceof TypeError && error.message === 'Failed to fetch';
      throw Object.assign(new Error('Failed to set article rating'), {
        type: isNetworkError ? 'NETWORK_ERROR' : 'SERVER_ERROR',
        cause: {
          message: (error as Error).message,
          timestamp: new Date().toISOString(),
          url,
          online: typeof navigator !== 'undefined' ? navigator.onLine : 'unknown',
        },
      });
    });
}

export async function getArticleRating(articleId: string, visitorSecret: string, signal?: AbortSignal) {
  const host = apiHost();
  const url = `${host}/web/articles/rating/${articleId}/${visitorSecret}`;
  if (!host) throw new Error('apiHost is not defined');

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal,
    });

    switch (response.status) {
      case HttpStatuses.received:
      case HttpStatuses.created:
        return await response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error(`Unexpected status: ${response.status}`);
    }
  } catch (error) {
    const isNetworkError = error instanceof TypeError && error.message === 'Failed to fetch';
    throw Object.assign(new Error('Failed to get article rating'), {
      type: isNetworkError ? 'NETWORK_ERROR' : 'SERVER_ERROR',
      cause: {
        message: (error as Error).message,
        timestamp: new Date().toISOString(),
        url,
        online: typeof navigator !== 'undefined' ? navigator.onLine : 'unknown',
      },
    });
  }
}
